import React from 'react';

import {
  ServiceTitanApiPhoneCallProviderData,
  ServiceTitanPortalV2PhoneCallProviderData,
  TimezoneAbbreviationEnum
} from '_lib/api/apiTypes.shim';
import { Typography } from '_lib/components/Typography/Typography';
import { TextBlockTypography } from '_lib/featureComponents/TextBoxTypography/TextBoxTypography';
import { DateUtils, DateFormatEnum } from '_lib/utils/date.utils';
import { getAppointmentNumberAndStatus } from '_lib/utils/helpers';

export const PhoneCallStAppointment = (
  appointment: NonNullable<
    ServiceTitanApiPhoneCallProviderData['appointment'] | ServiceTitanPortalV2PhoneCallProviderData['appointment']
  >,
  jobNumber: string,
  timezone: TimezoneAbbreviationEnum
) => {
  return (
    <>
      <TextBlockTypography text={getAppointmentNumberAndStatus(appointment, jobNumber || '')} />
      <Typography>
        <b>Start: </b>
        {DateUtils.todayOrFormat(appointment.start, {
          timezone,
          fullFormat: DateFormatEnum.DateTimeWeekdayShort
        })}
      </Typography>
      <Typography>
        <b>End: </b>
        {DateUtils.todayOrFormat(appointment.end, {
          timezone,
          fullFormat: DateFormatEnum.DateTimeWeekdayShort
        })}
      </Typography>
      {(() => {
        const arrivalWindowStart = appointment.arrivalWindowStart;
        const arrivalWindowEnd = appointment.arrivalWindowEnd;
        if (!arrivalWindowStart && !arrivalWindowEnd) {
          return <></>;
        }
        const startDisplay = arrivalWindowStart
          ? DateUtils.todayOrFormat(arrivalWindowStart, {
              timezone
            })
          : 'Unknown start';

        const endDisplay = arrivalWindowEnd
          ? DateUtils.todayOrFormat(arrivalWindowEnd, {
              timezone
            })
          : 'Unknown end';

        return (
          <Typography>
            <b>Arrival Window: </b>
            {`${startDisplay} - ${endDisplay}`}
          </Typography>
        );
      })()}
    </>
  );
};
